import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import vietrroLogo from '@/assets/images/logo/vietrro.svg'
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaLinkedin } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

const Footer = () => {
    const { t } = useTranslation('commonNew');
    // const currentYear = new Date().getFullYear()

    return (
        <footer className="pt-5 bg-mode">
            <Container className="pt-4">
                <Row className="g-4">
                    <Col sm={6} lg={3}>
                        <img src={vietrroLogo} alt="Vietrro" height="40" />
                        <p className="mt-3">
                            {t('footer.description', {defaultValue: 'Giải pháp bảo vệ bản quyền và danh tính toàn diện cho các nhà sáng tạo nội dung.'})}
                        </p>
                        <div className="d-flex gap-3 mt-3">
                            <a href="/" className="text-primary fs-5"><FaFacebook /></a>
                            <a href="/" className="text-primary fs-5"><FaTwitter /></a>
                            <a href="/" className="text-primary fs-5"><FaInstagram /></a>
                            <a href="/" className="text-primary fs-5"><FaYoutube /></a>
                            <a href="/" className="text-primary fs-5"><FaLinkedin /></a>
                        </div>
                    </Col>

                    <Col sm={6} lg={3}>
                        <h5 className="mb-4">
                            {t('footer.feature.title', {defaultValue: 'Điểm nổi bật'})}
                        </h5>
                        <ul className="nav flex-column">
                            <li className="nav-item"><Link className="nav-link pt-0" to="/">
                                {t('footer.feature.identityProtection', {defaultValue: 'Bảo vệ danh tính'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.feature.copyrightMonitoring', {defaultValue: 'Giám sát bản quyền'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.feature.autoDMCA', {defaultValue: 'DMCA tự động'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.feature.aiUsageDetection', {defaultValue: 'Phát hiện sử dụng AI'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.feature.marketplace', {defaultValue: 'Marketplace'})}
                            </Link></li>
                        </ul>
                    </Col>

                    <Col sm={6} lg={3}>
                        <h5 className="mb-4">
                            {t('footer.support.title', {defaultValue: 'Hỗ trợ'})}
                        </h5>
                        <ul className="nav flex-column">
                            <li className="nav-item"><Link className="nav-link pt-0" to="/">
                                {t('footer.support.helpCenter', {defaultValue: 'Trung tâm trợ giúp'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.support.community', {defaultValue: 'Cộng đồng'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.support.contactSupport', {defaultValue: 'Liên hệ hỗ trợ'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.support.faq', {defaultValue: 'Câu hỏi thường gặp'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.support.resources', {defaultValue: 'Tài nguyên'})}
                            </Link></li>
                        </ul>
                    </Col>

                    <Col sm={6} lg={3}>
                        <h5 className="mb-4">
                            {t('footer.aboutUs.title', {defaultValue: 'Về chúng tôi'})}
                        </h5>
                        <ul className="nav flex-column">
                            <li className="nav-item"><Link className="nav-link pt-0" to="/">
                                {t('footer.aboutUs.aboutUs', {defaultValue: 'Giới thiệu'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.aboutUs.careers', {defaultValue: 'Tuyển dụng'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.aboutUs.blog', {defaultValue: 'Blog'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.aboutUs.press', {defaultValue: 'Báo chí'})}
                            </Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/">
                                {t('footer.aboutUs.partners', {defaultValue: 'Đối tác'})}
                            </Link></li>
                        </ul>
                    </Col>
                </Row>
            </Container>
            <hr className="mb-0 mt-5" />
            <div className="py-3">
                <Container>
                    <Row>
                        <Col lg={6}>
                            <ul className="nav justify-content-center justify-content-lg-start">
                                <li className="nav-item">
                                    <Link className="nav-link ps-0" to="/">
                                        {t('footer.termsOfUse', {defaultValue: 'Điều khoản sử dụng'})}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">
                                        {t('footer.privacyPolicy', {defaultValue: 'Chính sách bảo mật'})}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">
                                        {t('footer.legal', {defaultValue: 'Pháp lý'})}
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">
                                        {t('footer.sitemap', {defaultValue: 'Sitemap'})}
                                    </Link>
                                </li>
                            </ul>
                        </Col>
                        <Col lg={6}>
                            <p className="flex justify-center lg:justify-end items-center m-0 h-full">
                                {t('footer.copyright', {defaultValue: '© 2025 Vietrro. Bảo lưu mọi quyền.'})}
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    )
}

export default Footer